// "use strict";

angular.module('app.factories.favorite', []).// app.factories.favorite-module
// -------------------------------------------//
//              Favorites Factory
// -------------------------------------------//

factory('f_Favorites', ['$rootScope',
    function ($rootScope) {
        var Favorites = [];
        var obj = {


            setFavorites: function (f) {
               Favorites = f;
                $rootScope.$broadcast('favorites-update');
                return obj;

            },
            getFavorites : function(){
                return Favorites;
            },
            addFavorite : function(f)
            {
                // Remove existing Favorites by FavoriteId
                for(let i = Favorites.length - 1; i >= 0; i--) {
                    if(Favorites[i].FavoriteId === f.FavoriteId)
                    {
                        Favorites.splice(i,1);
                    }
                }
                // Add new Favorite
                /* angular-restmod bug - can't add form one collections to another. #298
                   See: https://github.com/platanus/angular-restmod/issues/298 */
                const oldPosition = f.$position;
                f.$position = undefined;
                Favorites.$add(f);
                f.$position = oldPosition;
                $rootScope.$broadcast('favorites-add');

            },
            removeFavorite : function(f)
            {
                // Remove existing Favorites by FavoriteId
                for(var i = 0; i < Favorites.length; i++) {
                    if(Favorites[i].FavoriteId == f.FavoriteId)
                    {

                        Favorites.splice(i,1);

                    }
                }
                $rootScope.$broadcast('favorites-remove');
            },

            objectHasFavorite: function (o, oType, write) {
                var filter;


                switch (oType) {
                    case 'Datapoint':
                        filter = {
                            _type :'BMS.Shared.Model.System.FavoriteDatapoint, BMS.Shared',
                            DeviceId: o.DatapointValue.DeviceId,
                            DatapointConfigId: o.DatapointConfig.DatapointConfigId
                        } ;
                        break;
                    case "Scene":
                        filter = {
                            _type :'BMS.Shared.Model.System.FavoriteScene, BMS.Shared',
                            SceneId : o.SceneId
                        };
                        break;
                    case "Device":
                        filter = {_type :'BMS.Shared.Model.System.FavoriteDevice, BMS.Shared',
                            DeviceId : o.DeviceId};
                        break;
                    case "Favorite":
                        filter = {FavoriteId : o.FavoriteId};
                        break;
                    case "MenuEntry":
                       if(o.CustomActionName){
                           filter = {
                               CustomActionName : o.CustomActionName,
                               DeviceId : o.DeviceId
                           };
                           // Deviceid
                       }else{
                           filter = {
                               MenuEntryId : o.MenuEntryId,
                               DeviceId : o.DeviceId
                           };
                       }
                    break;
                }


                var back = false;
                for(var i = 0; i < Favorites.length; i++)
                {
                    var allPropsSame = true;
                    for(var key in filter)
                    {

                            if(!filter.hasOwnProperty(key) || !Favorites[i].hasOwnProperty(key) || Favorites[i][key] != filter[key])
                            {
                                allPropsSame = false;
                                break;
                            }
                    }
                    if(allPropsSame == true)
                    {
                        back = Favorites[i];
                    }
                }

                return back;
            }
        }
        return obj;
    }
]);
